const routes = [
  {
    index: true,
    label: 'Alex Johny',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  // {
  //   label: 'Resume',
  //   path: '/resume',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
